export const ExportJobStatus: Record<ExportJobStatusType, ExportJobStatusType> = {
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
  INPROGRESS: "INPROGRESS",
};

export type ExportJobStatusType = "SUCCESS" | "FAILED" | "INPROGRESS";
